"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../../common/constants/states");
var StudentLocationsCreateHighschoolController = /** @class */ (function () {
    function StudentLocationsCreateHighschoolController($state, UsersModel, UserService, FlashService, SchoolsModel) {
        var _this = this;
        this.$state = $state;
        this.UsersModel = UsersModel;
        this.UserService = UserService;
        this.FlashService = FlashService;
        this.SchoolsModel = SchoolsModel;
        this.states = states_1.States;
        this.submitted = false;
        this.student = UserService.getCurrentUser();
        this.hasPickupLocation = false;
        this.highSchoolName = null;
        this.submitPickupLocation = this.submitPickupLocation.bind(this);
        UsersModel.getPickupLocations(this.student.id).then(function (response) {
            _this.state = response.pickuplocations[0].address.state;
        });
    }
    StudentLocationsCreateHighschoolController.prototype.searchHighSchools = function () {
        var _this = this;
        this.highschools = [];
        this.loadingSchools = true;
        var data = {
            name: this.highSchoolName,
            state: this.state,
        };
        this.SchoolsModel.getHighSchools(data).then(function (response) {
            _this.loadingSchools = false;
            _this.highschools = response;
        });
    };
    StudentLocationsCreateHighschoolController.prototype.selectHighschool = function () {
        var selectedHighSchool = this.selectedHighSchool;
        this.highschool = {
            name: selectedHighSchool.name,
            street: selectedHighSchool.street,
            city: selectedHighSchool.city,
            state: selectedHighSchool.state,
            zip: selectedHighSchool.zip,
            lat: selectedHighSchool.lat,
            lng: selectedHighSchool.lng,
        };
        this.hasPickupLocation = true;
    };
    StudentLocationsCreateHighschoolController.prototype.submitPickupLocation = function () {
        var _this = this;
        this.submitted = true;
        this.UsersModel.addPickupLocation({
            student_id: this.student.id,
            pickuplocation: {
                name: this.highschool.name,
                street: this.highschool.street,
                city: this.highschool.city,
                state: this.highschool.state,
                zip: this.highschool.zip,
                lat: this.highschool.lat,
                lng: this.highschool.lng,
            },
        })
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.$state.go("drivecoach.student.dashboard.locations.index", {}, { reload: true });
        })
            .catch(function (response) {
            _this.submitted = false;
        });
    };
    return StudentLocationsCreateHighschoolController;
}());
StudentLocationsCreateHighschoolController.$inject = [
    "$state",
    "UsersModel",
    "UserService",
    "FlashService",
    "SchoolsModel",
];
exports.default = StudentLocationsCreateHighschoolController;
